
/*
    removeStorage: removes a key from localStorage and its sibling expiracy key
    params:
        key <string>     : localStorage key to remove
    returns:
        <boolean> : telling if operation succeeded
*/
export function removeStorage (key) {
    try {
        localStorage.setItem(key, '');
        localStorage.setItem(`${key}_expiresIn`, '');
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.log(`removeStorage: Error removing key [${key}] from localStorage: ${JSON.stringify(e)}`);
        return false;
    }
    return true;
}

/*
    getStorage: retrieves a key from localStorage previously set with setStorage().
    params:
        key <string> : localStorage key
    returns:
        <string> : value of localStorage key
        null : in case of expired key or failure
*/
export function getStorage (key) {
    // epoch time, lets deal only with integer
    const now = Date.now();
    // set expiration for storage
    let expiresIn = localStorage.getItem(`${key}_expiresIn`);
    if (expiresIn === undefined || expiresIn === null) {
        expiresIn = 0;
    }

    expiresIn = Math.abs(expiresIn);
    if (expiresIn < now) {
        // Expired
        removeStorage(key);
        return null;
    }
    else {
        try {
            const value = localStorage.getItem(key);
            return value;
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.log(`getStorage: Error reading key [${key}] from localStorage: ${JSON.stringify(e)}`);
            return null;
        }
    }
}

/*
    setStorage: writes a key into localStorage setting a expire time
    params:
        key <string>     : localStorage key
        value <string>   : localStorage value
        expires <number> : number of seconds from now to expire the key
    returns:
        <boolean> : telling if operation succeeded
*/
export function setStorage (key, value, expires) {
    if (expires === undefined || expires === null) {
        // default: seconds for 1 day
        expires = 24 * 60 * 60;
    }

    // millisecs since epoch time, lets deal only with integer
    const now = Date.now();
    const schedule = now + expires * 1000;
    try {
        localStorage.setItem(key, value);
        localStorage.setItem(`${key}_expiresIn`, schedule);
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.log(`setStorage: Error setting key [${key}] in localStorage: ${JSON.stringify(e)}`);
        return false;
    }
    return true;
}

/*
    getUserRole: retrieves the user role id from localStorage
    returns:
        <number> : role id of the user
        null : in case of error or no user found
*/
export function getUserRole () {
    try {
        const sessionUser = localStorage.getItem('sessionUser');

        if (!sessionUser) {
            return null;
        }

        const user = JSON.parse(sessionUser);
        return user?.roles?.[0]?.role?.id || null;
    }
    catch (error) {
        return null;
    }
}
